import React, { useState } from "react";
import { usePinMode } from "../lib/pinMode";
import { findSegFor } from "../lib/segRegistry";

// Compact, thumb-friendly page-filter bar for mobile. Renders each control as a
// small "LABEL value" chip; tapping opens a bottom-sheet (above the nav) with the
// options. Lives in the bottom mobile context bar so filters are never the first
// thing on screen.
// groups: [{ id, label, currentLabel, options:[{k,l,active,onSelect}] }]
export function MobilePageControls({ groups = [] }) {
    const [open, setOpen] = useState(null);
    const pinOn = usePinMode();
    if (!groups.length) return null;
    const lastIdx = groups.length - 1;
    return (
        <div className="flex flex-wrap items-center justify-center gap-1.5 w-full" data-testid="mobile-page-controls">
            {groups.map((g, idx) => {
                const isOpen = open === g.id;
                // Anchor the sheet to THIS chip: first→left edge, last→right edge,
                // middle→centred over the chip, so the thumb never travels.
                const align = idx === 0 ? "left-0" : idx === lastIdx ? "right-0" : "left-1/2 -translate-x-1/2";
                return (
                    <div key={g.id} className="relative min-w-[92px] max-w-[46%]">
                        <button type="button" onClick={() => setOpen((o) => (o === g.id ? null : g.id))} data-testid={`mpc-chip-${g.id}`}
                            className={`w-full inline-flex items-center justify-center gap-1 rounded-full border px-2 py-1.5 transition-colors ${isOpen ? "border-[#9D4CDD] bg-[#9D4CDD]/20" : "border-white/12 bg-white/[0.04] active:bg-white/10"}`}>
                            <span className="text-[8px] font-bold uppercase tracking-wider text-white/40 leading-none shrink-0">{g.label}</span>
                            <span className="text-[11px] font-bold uppercase tracking-wider font-mono-stat text-white leading-none truncate">{g.currentLabel}</span>
                        </button>
                        {isOpen && (
                            <>
                                <div className="fixed inset-0 z-[58]" onClick={() => setOpen(null)} data-testid="mpc-scrim" />
                                <div className={`absolute bottom-full mb-2 ${align} z-[60] w-max max-w-[70vw]`} data-testid={`mpc-popover-${g.id}`}>
                                    <div className="rounded-2xl border border-white/12 bg-[#12141D] p-2.5 shadow-2xl shadow-black/60 animate-slide-up">
                                        <p className="text-[9px] font-black uppercase tracking-[0.18em] text-[#9D4CDD] mb-1.5 px-0.5 text-center">{g.label}</p>
                                        {g.node ? g.node : (() => {
                                            // Same pin as the desktop toggle: Fav Toggles on (or Shift) → tapping an option pins it.
                                            const seg = findSegFor(g.options.map((o) => o.k), g.options.find((o) => o.active)?.k);
                                            return (
                                                <div className="flex flex-wrap gap-1.5 justify-center">
                                                    {pinOn && seg && <p className="w-full text-center text-[9px] font-black uppercase tracking-[0.16em] text-[#F5B301] mb-0.5" data-testid={`mpc-pin-hint-${g.id}`}>Tap to pin as default</p>}
                                                    {g.options.map((o) => (
                                                        <button key={o.k} type="button" onClick={(e) => { if ((pinOn || e.shiftKey) && seg) seg.onPin(o.k); o.onSelect(); setOpen(null); }} data-testid={`mpc-opt-${g.id}-${o.k}`}
                                                            className={`relative px-3 py-2 rounded-lg text-[11px] font-bold uppercase tracking-wider font-mono-stat transition-colors ${o.active ? "bg-[#9D4CDD] text-white" : "bg-white/[0.04] text-[#C9A6F0] active:bg-white/10"}`}>
                                                            {o.l}
                                                            {seg && seg.pinnedKey === o.k && <span className="absolute top-0.5 right-0.5 h-1.5 w-1.5 rounded-full bg-[#F5B301]" data-testid={`mpc-pin-${g.id}-${o.k}`} />}
                                                        </button>
                                                    ))}
                                                </div>
                                            );
                                        })()}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                );
            })}
        </div>
    );
}

export default MobilePageControls;

